export const BASE_AUTH_PATH = `/public/frontend/config`;

export const getPathname = (
    startName: 'files' | 'tables' | 'calendar',
    wellId: string | number,
    endName: string,
): string => {
    return `/${startName}/${wellId}/${endName}`;
};
